import { useState } from 'react'
import useOnPremAgentClient from '~/api/OnPremAgentClient/useOnPremAgentClient'
import { DataIngestor, UploadDatasetRequest } from '~/api/onPremAgent/dataIngestorsAPI'
import Button from '~/components/buttons/Button'
import { StructuredDataFormData } from '~/components/StructuredDataForm/StructuredDataForm'
import Toaster from '~/components/Toaster'
import cs from './generate_test_data.scss'
import ManualDatasetUploadForm from './ManualDatasetUploadForm'

export default function ManualDatasetUpload(props: { dataIngestor: DataIngestor }) {
  const client = useOnPremAgentClient()
  const [manualUploadDataParams, setManualUploadDataParams] =
    useState<StructuredDataFormData>({})
  const { dataIngestor } = props
  const uploadDataset = async () => {
    try {
      Toaster.show({
        message: 'Uploading dataset...',
        intent: 'primary',
      })
      await client.dataIngestors.uploadDataset(
        dataIngestor.uuid,
        manualUploadDataParams as UploadDatasetRequest,
      )

      // Reset form after form submission
      setManualUploadDataParams({})
      Toaster.show({
        message: 'Uploaded new dataset.',
        intent: 'success',
      })
    } catch (_e) {
      Toaster.show({
        message: 'Failed to upload dataset.',
        intent: 'danger',
      })
    }
  }

  return (
    <div className={cs.generateTestData}>
      <div className={cs.formContainer}>
        <ManualDatasetUploadForm
          className={cs.configForm}
          manualUploadDataParams={manualUploadDataParams}
          setManualUploadDataParams={setManualUploadDataParams}
        />
      </div>
      <div className={cs.footer}>
        <Button
          type='primary'
          label='Upload Dataset'
          onClick={uploadDataset}
          className={cs.button}
          disabled={dataIngestor.status !== 'live'}
        />
      </div>
    </div>
  )
}
